<script lang="ts">
  import { onMount } from "svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import { Table } from "../../components/Table";
  import { progettoDtoFields } from "../../utils/TableFields/project-dto.fields";
  import { PermissionService } from "../../utils/misc/permission-utils";
    import { user } from "../../app.store";

  $: tableFields = [...progettoDtoFields];

  let cancreate : boolean = PermissionService.isAllowedTo($user, 'companies.cancreate');
  let candelete : boolean = PermissionService.isAllowedTo($user, 'companies.candelete');


  import {
    filter,
    loading,
    records,
    pagination,
    initList,
    onEdit,
    onPageChange,
    search,
    clearSearch, onExportProjects,
  } from "./project.store";
import FormField from "../../components/Form/FormField.svelte"; 
import Icon from "../../components/Icon.svelte";
import Button from "../../components/Button.svelte";
    import DateInput from "../../components/Form/Fields/DateInput.svelte";
    import CompanyDropdown from "../../components/Business/CompanyDropdown.svelte";
    import ProjectStatesDropdown from "../../components/Business/ProjectStatesDropdown.svelte";
    import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";

  onMount(() => {
    initList();
    let client_size = window.outerWidth - (window.outerWidth <1600?310:400);
    window.document.getElementById("table_container").style.width = client_size + "px";
  });

</script>

  <SearchHeader
    entitySingular={'progetto'}
    entityPlural={'progetti'}
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    bind:searchValue={$filter.criteria.query}
    on:search={search}
  >
  <div slot="search" class="level">
     
    

    <div class="level-item" >
      <div>
        <FormField>
          <DateInput
            name=""
            placeholder="Data Inizio"
            required={false}
            bind:value={$filter.criteria.dataFrom} 
          />
        </FormField>
        <FormField>
          <NumberInput
            name=""
            placeholder="Filtra per codice commessa..."
            required={false}
            bind:value={$filter.criteria.codiceCommessa} 
          />
        </FormField>
      </div>
    </div>

    <div class="level-item" >
      <div>
        <FormField>
          <DateInput
            name=""
            placeholder="Data Fine"
            required={false}
            bind:value={$filter.criteria.dataTo} 
          />
        </FormField>
        <FormField>
          <CompanyDropdown
            name=""
            placeholder="Filtra per cliente..."
            required={false}
            bind:value={$filter.criteria.clientId} 
          />
        </FormField>
      </div>
    </div>

    <div class="level-item" >
      <div>
        <FormField>
          <Input
                  name=""
                  placeholder="Filtra per ufficio..."
                  required={false}
                  bind:value={$filter.criteria.ufficio}
          />
        </FormField>
        <FormField>
          <ProjectStatesDropdown
            name=""
            placeholder="Filtra per stato..."
            required={false}
            bind:value={$filter.criteria.stato} 
            on:select={search}
          />
        </FormField>
      </div>
    </div>

    <div class="level-item">
      <p class="control">
        <Button on:click={search}>
          <Icon name="search" />

          <span> Cerca </span>
        </Button>
      </p>
    </div>

    <div class="level-item">
      <p class="control">
        <Button on:click={clearSearch}>Azzera</Button>
      </p>
    </div> 
   
  </div>
  </SearchHeader>

  <div id="table_container" style="width: 100%;
    box-sizing: BORDER-BOX;overflow-x: scroll;" >
    <Table
    klass="large-table"
    loading={$loading}
    fields={tableFields}
    records={$records.map(x => x.progetto)}
    pagination={$pagination}
    createEnabled={cancreate}
    editEnabled={false}
    showEnabled={true}
    exportEnabled={true}
    deleteEnabled={candelete}
    on:show={(e) => onEdit(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
    on:export={(e) => onExportProjects()}
  />

  </div>
  

  

<style> 
  :global .large-table {
    min-width:4000px;
}
</style> 